import React, { useState } from "react";
import LaddaButton from "../../../components/buttons/laddaButton";
import { icons } from "../../../constants";
import { CustomTabPanel } from "../../../components/tabComponent";
import RiskDetailModal from "./riskDetailModal";
import { formatTextWithLineBreaks } from "../../../utils/utilsFunctions";
import { useSelector } from "react-redux";
import { isRoleUtil } from "../../../utils/AuthorizedUtils/360Report";
import RiskVerificationModal from "./riskVerificationModal";
import StrategyRelationsTable from "../../../components/StrategyRelationsTable";
import { isRiskVersion } from "../../../utils/riskAndOportunityVersion";

const RiskDetailsTab = ({
  data,
  getRisk,
  isEditionAvailable,
  updateRiskupdateDate
}) => {
  const [riskDetailModal, setRiskDetailModal] = useState(false);

  const userData = useSelector((state) => state.userData.userData);

  const handleClose = () => {
    setRiskDetailModal(false);
  };

  const openModal = () => {
    setRiskDetailModal(true);
  };

  const useVersion2 = isRiskVersion(data?.year, data?.month) === 2;

  return (
    <div>
      <CustomTabPanel value="0">
        {useVersion2 && (
          <>
            <h2 className="gm-title">Tipo de Riesgo:</h2>
            <p className="content-text">{data?.riskTypeName ?? "—"}</p>
          </>
        )}
        <h2 className="gm-title">Descripción:</h2>
        <p className="content-text">{data?.description}</p>
        <h2 className="gm-title">Causa Básica:</h2>
        <p className="content-text">{formatTextWithLineBreaks(data?.causes)}</p>
        <h2 className="gm-title">Consecuencia/Efecto:</h2>
        <p className="content-text">
          {formatTextWithLineBreaks(data?.consequences)}
        </p>
        <h2 className="gm-title">Estrategia {data?.strategyName}:</h2>
        <p className="content-text">
          {formatTextWithLineBreaks(data?.strategyDescription)}
        </p>
        <StrategyRelationsTable strategyId={data?.strategyId} />

        <div className="j-center">
          {isEditionAvailable && (
            <LaddaButton
              variant="contained"
              onClick={() => {
                openModal();
              }}
            >
              <div className="IHContainer align-rigth">
                <img
                  className="btn-icon"
                  src={icons.editWhite}
                  alt="icon"
                  style={{ marginRight: "10px" }}
                />
                <p className="button_text">Editar</p>
              </div>
            </LaddaButton>
          )}
        </div>
      </CustomTabPanel>
      <RiskDetailModal
        open={riskDetailModal}
        handleClose={handleClose}
        data={data}
        getRisk={getRisk}
        isEditionAvailable={isEditionAvailable}
        updateRiskupdateDate={updateRiskupdateDate}
      />
    </div>
  );
};

export default RiskDetailsTab;
